import { Component, OnInit, ViewChild } from '@angular/core';
import notify from 'devextreme/ui/notify';
import {
  AssemblyAction,
  CustomDialogAction,
  AttributesEntity
} from '../../models/configuration.model';
import { Map } from '../../models/objects.model';
import { BafAgentService } from '../../core/services/baf-agent/baf-agent.service';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { FileSelectionStoreService } from '../../services/file-selection-store/file-selection-store.service';
import { UploadService } from '../../services/upload/upload.service';
import { DialogControllerService } from '../../services/dialog-controller/dialog-controller.service';
import { NotificationService } from '../../services/notification/notification.service';
import { UploadState } from '../../services/upload/upload-state';
import { FunctionStoreService } from '../../services/function-store/function-store.service';

// TODO MK-REF
@Component({
  selector: 'baf-single-view-custom-action',
  templateUrl: './single-view-custom-action.component.html',
  styleUrls: ['./single-view-custom-action.component.css']
})
export class SingleViewCustomActionComponent implements OnInit {
  action: CustomDialogAction;
  attributes: AttributesEntity[] = [];
  isPopupVisible = false;
  popupTitle: string;

  constructor(
    private storeService: DataStoreService,
    private upload: UploadService,
    private fileStore: FileSelectionStoreService,
    private bafAgent: BafAgentService,
    private dialogController: DialogControllerService,
    private functionStore: FunctionStoreService,
    private notifier: NotificationService
  ) {
    storeService.getCustomDialogSingleViewContent().subscribe(customDialogAction => {
      this.action = customDialogAction;
      this.popupTitle = this.action.title.name;
      this.isPopupVisible = !!customDialogAction;
      if (this.isPopupVisible) {
        this.loadComponents();
      }
    });
  }

  private loadComponents() {
    if (this.action) {
      this.attributes = this.action.attributes;
      if (this.attributes.length >= 1) {
        for (const attribute of this.attributes) {
        }
      }
    }
  }

  onButtonClick(functionId) {
    const map: Map = {};

    for (const param of this.attributes) {
      if (param.businessType != 7) {
        const value = document.getElementById(param.id).getElementsByTagName('input')[0].value;
        if (!value) {
          this.notifier.error('Brak uzupełnienia atrybutu ' + param.displayName.name);
          return;
        }
        map[param.id] = value;
      }
    }

    const currentFunction = this.action.functions.find(func => func.id === functionId);
    const assemblyAction: AssemblyAction = currentFunction.action as AssemblyAction;

    if (assemblyAction.actionType === 'AssemblyAction') {
      const form = new FormData();
      form.append('assemblyAction', JSON.stringify(assemblyAction));
      form.append('data', JSON.stringify({ ...map, ...this.action.inputParams }));
      for (let index = 0; index < this.fileStore.files.length; index++) {
        form.append('files', this.fileStore.files[index], this.fileStore.files[index].name);
      }
      if (this.fileStore.files.length) this.uploadData(form);
      else
        this.bafAgent
          .executeAssemblyAction(form, {})
          .subscribe(
            data =>
              this.refreshAfterAction(
                'Zapisano raport niezgodności do zawiadomienia numer ' + data,
                false
              ),
            error =>
              this.refreshAfterAction(
                'Wystąpił błąd podczas zapisu raportu niezgodności: ' +
                  error.error.ExceptionMessage,
                true
              )
          );
    }
  }

  private refreshAfterAction(message: string, error: boolean): void {
    this.isPopupVisible = false;
    if (error) this.notifier.error(message);
    else this.notifier.success(message);
    this.functionStore.refreshFunctions();
    this.storeService.refreshNode();
  }

  private uploadData(form: FormData) {
    let started = false;
    this.upload.uploadData(form).subscribe(
      event => {
        if (!started) {
          this.isPopupVisible = false;
          this.dialogController.openUploadDialog();
          started = true;
        }
        switch (event.state) {
          case UploadState.Started:
            break;
          case UploadState.Progress:
            break;
          case UploadState.Finished:
            this.notifier.success('Wysłano wypis');
            this.afterSuccessfulRegistration();
            this.dialogController.closeDialog();
            this.isPopupVisible = false;
            break;
        }
      },
      error => {
        this.notifier.error('Problem podczas zapisu: ' + error.error.Message);
        this.dialogController.closeDialog();
        this.isPopupVisible = false;
      }
    );
  }

  private afterSuccessfulRegistration() {
    this.clearInputValues();
    this.functionStore.refreshFunctions();
    this.storeService.refreshNode();
  }

  private clearInputValues() {
    this.forEachAttributeInput((attribute, input) => (input.value = null));
    this.fileStore.clear();
  }

  private forEachAttributeInput(
    action: (attribute: AttributesEntity, input: HTMLInputElement) => void
  ): void {
    for (const attribute of this.attributes) {
      if (attribute.businessType !== 7 && attribute.businessType !== 9) {
        const input = document.getElementById(attribute.id).getElementsByTagName('input')[0];
        action(attribute, input);
      }
    }
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/single-view-custom-action/single-view-custom-action.component.ts